module.exports = __webpack_public_path__ + "img/health-plan.4a52f90c.svg";